import data from './translation.json';

export const DEFAULT_LANGUAGE = 'en';
export const translation = data;
